<template>
    <v-row class="mx-0 fontsize-14" no-gutters>
        <v-col class="background-neutral-muted pa-6 gray-box">
            <span class="font-weight-700 text-color-ui-text-neutral-100">
                All Inclusive Bundle
            </span>

            <p class="text-color-ui-text-neutral-100 mb-6">
                Printing on both the Stationery and Envelope is included, along
                with any Liner of your choice
            </p>

            <div class="icon-div-box">
                <div class="stationery-section">
                    <div class="stationery-content">
                        <v-img
                            :src="stationeryIcon"
                            width="35"
                            height="30"
                            contain
                        />
                        <span
                            class="font-weight-700 text-color-ui-text-neutral-100"
                            >Stationery</span
                        >
                    </div>
                </div>

                <div class="envelope-section">
                    <div class="envelope-content">
                        <v-img
                            :src="envelopeIcon"
                            width="36"
                            height="36"
                            contain
                        />
                        <span>
                            <span
                                class="font-weight-700 text-color-ui-text-neutral-100"
                                >Envelope</span
                            >
                            with unique Liner
                        </span>
                    </div>
                </div>
            </div>
        </v-col>
    </v-row>
</template>
<script>
import stationeryIcon from "@/assets/stationery_icon.svg";
import envelopeIcon from "@/assets/envelope_icon.svg";

export default {
    name: "GrayBoxForPersonalizedProductComponent",
    data: () => ({
        envelopeIcon,
        stationeryIcon,
    }),
};
</script>
<style src="./GrayBoxForPersonalizedProduct.scss" lang="scss" />
